<template>
  <LayoutGradient :title="$t('core_care_units.form.unidades')" icon="fa-hospital">
    <template v-slot:headerRight>
      <b-btn-group>
        <b-btn variant="outline-info" @click="$router.back()">
          <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
        </b-btn>
      </b-btn-group>
    </template>
    <div class="m-3 mt-n10">
      <b-card>
        <SimpleForm :fields="fields" :model="model" @submit="onSubmit">
          <template v-slot:field(core_company.core_company_id)>
            <b-form-group :label="$t('core_care_units.form.empresa_principal')">
              <SelectCoreCompanies :model="company" @input="evt => model.core_company_id = evt.value" />
            </b-form-group>
          </template>
        </SimpleForm>
      </b-card>
    </div>
  </LayoutGradient>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import LayoutGradient from "@/templates/LayoutGradient";
import SimpleForm from "@/components/FormGenerator/SimpleForm";
import CareUnitsRepository from "@/repositories/CareUnitsRepository";
import SelectCoreCompanies from "@/pages/corecompanies/components/SelectCoreCompanies";

export default {
  name: "Form",
  components: {SelectCoreCompanies, SimpleForm, LayoutGradient},
  computed: {
    ...mapGetters({
      companies: 'corecompanies/all',
      careunit: 'corecareunits/current',
      isLoading: 'corecareunits/isLoading'
    }),
    company() {
      if (this.model.core_company_id && this.companies) {
        const model = this.companies.find(c => this.model.core_company_id === c.id)
        if (model) {
          return {
            value: model.id,
            label: model.name
          }
        }        
      }
      return {}
    }
  },
  data() {
    return {
      fields: [
        {
          fieldsetLabel: this.$t('core_care_units.form.informacoes'),
          fieldset: 'info',
          fields: [
            {label: this.$t('core_care_units.form.nome'), name: 'name', description: this.$t('core_care_units.form.nome_descricao'),},
            {label: this.$t('core_care_units.form.mnemonico'), name: 'mnemonic', description: this.$t('core_care_units.form.mnemonico_descricao')},
            {label: 'Veus ID', name: 'veus_care_unit_id', description: this.$t('core_care_units.form.veus_id_descricao'), type: 'number'},
          ]
        },
        {
          fieldsetLabel: this.$t('core_care_units.form.vinculo'),
          fieldset: 'core_company',
          fields: [
            {label: this.$t('core_care_units.form.empresa_principal'), name: 'core_company_id', description: this.$t('core_care_units.form.empresa_principal_descricao')},
          ]
        }
      ],
      model: {
        id: null,
        name: '',
        mnemonic: '',
        veus_care_unit_id: null,
        core_company_id: null,
      },
      importing: {
        param: 'nome',
        text: null,
        id: null
      }
    }
  },
  methods: {
    ...mapActions([
      'corecareunits/listOne',
      'corecompanies/search',
    ]),
    onSubmit() {
      if (this.$route.params.id) {
        this.update()
      }else {
        this.create()
      }
    },
    create() {
      CareUnitsRepository.post(this.model).then(() => {
        this.$snotify.success(this.$t('core_care_units.form.unidade_criada_sucesso'))
        this.$router.push({name: 'corecareunits.index'})
      }).catch(error => {
        if (error.response.status === 422) {
          CareUnitsRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      CareUnitsRepository.put(this.careunit.id, this.model).then(() => {
        this.$snotify.success(this.$t('core_care_units.form.unidade_atualizada_sucesso'))
        this.$router.push({name: 'corecareunits.index'})
      }).catch(error => {
        if (error.response.status === 422) {
          CareUnitsRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('corecareunits/setCurrent', {})
    if (this.$route.params.id) {
      await this['corecareunits/listOne'](this.$route.params.id)
      this.model = {...this.model, ...this.careunit}
      if (this.companies.filter(c => this.careunit.core_company_id === c.id).length === 0){
        this['corecompanies/search']({filters: [['id', '=', this.careunit.core_company_id]]})
      }
    }
  }
}
</script>